import { useState } from 'react'
import { useSignup } from '../hooks/useSignup'
import Loader from './Loader'

const Signup = () => {
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const {signup, error, isLoading} = useSignup()

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        await signup(firstName, lastName, email, password, confirmPassword)
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <form className="signup" onSubmit={handleSubmit}>
            <h3>Sign up</h3>
            <label>First Name: </label>
            <input type="text" onChange={(e) => setFirstName(e.target.value)} value={firstName} />
            <label>Last Name: </label>
            <input type="text" onChange={(e) => setLastName(e.target.value)} value={lastName} />
            <label>Email: </label>
            <input type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
            <label>Password: </label>
            <input type="password" onChange={(e) => setPassword(e.target.value)} value={password} />
            <label>Confirm Password: </label>
            <input type="password" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
            <button disabled={isLoading}>Sign up</button>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default Signup